import React from 'react';
import PropTypes from 'prop-types';
import NoImage from './NoImage';

// TODO: BR-VEH-003 — Honda, Mercedes, Acura may require special image URL
// transformation. Details pending DS-005 MSS contract / GV v2 make-specific
// image contract clarification. For now, imageUrl from GV v2 is used as-is.
const VehicleImage = ({ imageUrl, alt }) => {
	if (imageUrl) {
		return (
			<img
				src={imageUrl}
				alt={alt}
				loading="lazy"
				className="vehicle-card__image"
			/>
		);
	}
	return <NoImage />;
};

VehicleImage.propTypes = {
	imageUrl: PropTypes.string,
	alt: PropTypes.string.isRequired
};

export default VehicleImage;
